import styled from 'styled-components'

export const Container = styled.div`
    cursor: pointer;
    height: 100%;
    position: relative;
    width: 100%;
`

export const Swatch = styled.div<{ isDragging: boolean }>`
    left: 0;
    overflow: visible;
    pointer-events: none;
    position: absolute;
    width: 0;

    &:before {
        background: inherit;
        border: 2px solid #fff;
        border-radius: 50%;
        box-sizing: border-box;
        content: '';
        filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.5));
        height: 20px;
        left: -10px;
        position: absolute;
        top: -10px;
        transform: scale(${({ isDragging }) => (isDragging ? 1.2 : 1)});
        width: 20px;
    }
`
